import { memo } from 'react'
import PropTypes from 'prop-types'
import { Card } from '@leroy-merlin-br/backyard-react-ui'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { CouponContainer } from 'lmcv/containers/Coupon'

import { CarouselSkeleton } from '../Skeleton'
import { ErrorMessage } from './ErrorMessage'
import * as S from '../styled'

function Money ({ data }) {
  const { money, activated } = data

  const carouselProps = {
    slidesPerView: 'auto',
    spaceBetween: 15,
    hasOffset: false
  }

  const couponResolver = data => {
    if (data.isRequest) {
      return <CarouselSkeleton size={5} />
    }

    if (!data.payload.length) {
      return <ErrorMessage />
    }

    return (
      <GenericCarousel {...carouselProps}>
        {data.payload.map(data => {
          return <CouponContainer key={data.id} {...data} />
        })}
      </GenericCarousel>
    )
  }

  return (
    <Card title="Vale Compras" addons={<S.Link to="/troque">Ver todos</S.Link>}>
      <S.Tabs>
        <S.TabList>
          <S.Tab selectedClassName="selected">Vale-compras</S.Tab>
          <S.Tab selectedClassName="selected">
            Vale-compras Ativados
            <S.TabBadge> {activated.payload.length}</S.TabBadge>
          </S.Tab>
        </S.TabList>

        <S.TabPanel selectedClassName="selected">{couponResolver(money)}</S.TabPanel>

        <S.TabPanel selectedClassName="selected">{couponResolver(activated)}</S.TabPanel>
      </S.Tabs>
    </Card>
  )
}

Money.propTypes = {
  data: PropTypes.shape({
    money: PropTypes.shape({
      isRequest: PropTypes.bool,
      payload: PropTypes.arr
    }),
    activated: PropTypes.shape({
      isRequest: PropTypes.bool,
      payload: PropTypes.arr
    })
  }).isRequired
}

export default memo(Money)
